// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leavesummarywidget-inline-1 {
  background: #0ea5e9;
}

.leavesummarywidget-inline-2 {
  color: #0ea5e9;
}

.leavesummarywidget-inline-3 {
  font-size: 11px;
  color: #64748b;
  margin-top: 6px;
}

.leavesummarywidget-dyn-1 {
  background: var(--leavesummarywidget-1-background);
}

.leavesummarywidget-dyn-2 {
  color: var(--leavesummarywidget-2-color);
}

.leavesummarywidget-dyn-3 {
  width: var(--leavesummarywidget-3-width);
  background: var(--leavesummarywidget-3-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/LeaveSummaryWidget.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD","sourcesContent":[".leavesummarywidget-inline-1 {\n  background: #0ea5e9;\n}\n\n.leavesummarywidget-inline-2 {\n  color: #0ea5e9;\n}\n\n.leavesummarywidget-inline-3 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 6px;\n}\n\n.leavesummarywidget-dyn-1 {\n  background: var(--leavesummarywidget-1-background);\n}\n\n.leavesummarywidget-dyn-2 {\n  color: var(--leavesummarywidget-2-color);\n}\n\n.leavesummarywidget-dyn-3 {\n  width: var(--leavesummarywidget-3-width);\n  background: var(--leavesummarywidget-3-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
